import type { ISODateString, LanguageLabel } from '@/shared/types';

export const TWO_FA_STATUS = {
  ENABLED: 'enabled',
  REQUIRED: 'required',
  OPTIONAL: 'optional',
} as const;

export type TokenType = 'bearer';

export type TwoFAStatus = (typeof TWO_FA_STATUS)[keyof typeof TWO_FA_STATUS];

export type Session = {
  userId: string;
  tokenType: TokenType;
  accessToken: string;
  accessExpiresIn: number;
  accessExpiresTo: ISODateString;
  refreshExpiresIn: number;
  refreshExpiresTo: ISODateString;
  additional?: {
    twoFAStatus: TwoFAStatus;
    isCorporate: boolean;
    isTest: boolean;
    isVerified: boolean;
    isPhone: boolean;
    preferredLanguage: LanguageLabel;
    residence: string;
    eWallet: string;
  };
};
